"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _Email = _interopRequireDefault(require("@material-ui/icons/Email"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _default = exports["default"] = function _default(_ref) {
  var count = _ref.count;
  var displayCount = (0, _react.useMemo)(function () {
    if ((0, _isNil["default"])(count) || count < 2) return '';
    return count > 9 ? '9+' : count.toString();
  }, [count]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-white bg-primary p-3 rounded-full relative flex shadow-lg cursor-grabbing"
  }, displayCount && /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-6 h-6 shadow rounded-full absolute bg-white text-primary text-xs flex justify-center items-center font-semibold",
    style: {
      top: -5,
      right: -5
    }
  }, displayCount), /*#__PURE__*/_react["default"].createElement(_Email["default"], null));
};
//# sourceMappingURL=index.js.map